import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { InfoCircleFill } from "react-bootstrap-icons";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import styled from "styled-components";
import { dedent } from "../../utils/analytics";
import { MarkdownContent } from "../SharedStyled";

const WidePopover = styled(Popover)`
    max-width: 720px;
`;

const PopoverScrollWrapper = styled.div`
    max-height: none;
    overflow: visible;
`;

const IconButton = styled.button`
    background: transparent;
    border: none;
    padding: 2px 4px;
    line-height: 1;
    cursor: pointer;
    color: #6c757d;
    vertical-align: middle;

    &:hover {
        color: #adb5bd;
    }
`;

type WidgetInfoButtonProps = {
    description: string;
    placement?: "top" | "bottom" | "left" | "right" | "auto";
};

const WidgetInfoButton: React.FC<WidgetInfoButtonProps> = ({ description, placement = "left" }) => {
    const popover = (
        <WidePopover id="widget-info-popover">
            <Popover.Content>
                <PopoverScrollWrapper>
                    <MarkdownContent>
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>{dedent(description)}</ReactMarkdown>
                    </MarkdownContent>
                </PopoverScrollWrapper>
            </Popover.Content>
        </WidePopover>
    );

    return (
        <OverlayTrigger trigger={["hover", "focus", "click"]} rootClose placement={placement} overlay={popover}>
            <IconButton type="button" aria-label="Widget information">
                <InfoCircleFill size={16} />
            </IconButton>
        </OverlayTrigger>
    );
};

export default WidgetInfoButton;
